import { takeLatest, put, select } from 'redux-saga/effects';
import { GET_GROUP, GET_GROUP_DATA, GET_GROUP_UTYPE_UNIT_LI, GET_GROUP_UTYPE_UNIT_LI_DATA, GET_GROUP_LI } from '../constants';
import { getGroupData, getGroupUtypeUnitLiData, getUnitLi, getGroupLiData } from '../actions';
import axios from 'axios';
import dlCommon from '../dlCommon';
import { dlGroupUTypeGet } from '../selectors';


export function* sgGetGroup(action) {
    const condS = JSON.stringify({$or: [{slug: action.payload},{id: action.payload}]});
    const url = dlCommon.apiUrlGet('dl-custom') + '?itemType=dl_group&cond=' + condS;
    const item = yield axios.get(url).then((res) => {
        return res.data[0];
    });
    
    yield put(getGroupData(item));

}

export function* sgGetGroupData(action) {
    // yield put(getUnitLiPage(1));
}

export function* sgGetGroupUtypeUnitLi(action) {
    const condS = JSON.stringify({slug: action.payload.dlGroupSlug});
    const url = dlCommon.apiUrlGet('dl-custom') + '?itemType=dl_group&cond=' + condS;
    const item = yield axios.get(url).then((res) => {
        return res.data[0];
    });
    yield put(getGroupUtypeUnitLiData(item));
}

export function* sgGetGroupUtypeUnitLiData(action) {
    let ancCondN = [];
    for (let [key, value] of Object.entries(action.payload.fCond)) {
        ancCondN.push({['fVals.' + key]: value});
    }
    let uType = yield select(dlGroupUTypeGet);
    uType = uType.toUpperCase();
    ancCondN.push({uType});
    let dlUnitCond = { $and: ancCondN };
    // console.log('dlUnitCond');
    // console.log(dlUnitCond);
    const dlUnitMaxPerPage = 50;

    yield put(getUnitLi({ dlUnitCond, dlUnitMaxPerPage }));
}

export function* sgGetGroupLi() {
    const url = dlCommon.apiUrlGet('dl-group');
    const item = yield axios.get(url).then((res) => {
        return res.data;
    });
    
    yield put(getGroupLiData(item));

}

export function* actWatchDlGroup() {
    yield takeLatest(GET_GROUP, sgGetGroup); 
    yield takeLatest(GET_GROUP_DATA, sgGetGroupData); 
    yield takeLatest(GET_GROUP_UTYPE_UNIT_LI, sgGetGroupUtypeUnitLi);
    yield takeLatest(GET_GROUP_UTYPE_UNIT_LI_DATA, sgGetGroupUtypeUnitLiData);
    yield takeLatest(GET_GROUP_LI, sgGetGroupLi); 
    // yield takeEvery(DELETE_UNIT, sgDeleteItem);
}

